import axios from "axios";
import { get } from "lodash";
import { API_URL } from "../Constants";
import { showToastMessage, logOut } from "./common";
import firebaseAuth from "../config/firebase-config";

const instance = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export const httpRequest = async (
    url,
    method = "post",
    data = [],
    isDownload,
    params = {}
) => {
    try {
        const user = firebaseAuth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            instance.defaults.headers.common.Authorization = `Bearer ${token}`;
        }
    } catch (err) {
        console.error("Failed to get auth token:", err);
    }

    try {
        const response = await instance({
            method,
            url,
            data,
            params,
        });
        if (isDownload) return response;
        return response.data;
    } catch (e) {
        if (
            get(e.response, "data.error.code", "") === "auth/id-token-expired"
        ) {
            try {
                const user = firebaseAuth.currentUser;
                if (user) {
                    const token = await user.getIdToken(true);
                    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
                    return httpRequest(url, method, data, isDownload, params);
                }
            } catch {
                logOut();
                return;
            }
        }
        return e.response;
    }
};

export const countryStateApi = async (request) => {
    try {
        const response = await axios({
            method: "get",
            url: `https://www.universal-tutorial.com/api/${request}`,
            headers: {
                Authorization: "Bearer " + (await generateToken2CountryAPI()),
            },
        });
        return response.data;
    } catch (e) {
        return e.response;
    }
};

const generateToken2CountryAPI = async () => {
    const token = await axios({
        method: "get",
        url: "https://www.universal-tutorial.com/api/getaccesstoken",
        headers: {
            Accept: "application/json",
            "api-token":
                "rLJyH9gqbws334xUIW8mlyXYIlJXb4Y5K425OxZ9HoB7rG3bJjiqaKWJ3eChpXv3PMU",
            "user-email": "naveen.bandela@styldod.com",
        },
    });

    return token.data.auth_token;
};
